var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Title',{staticClass:"has-text-centered"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"title has-text-centered"},[_c('i',[_vm._v("Page Not Found")])])
}]

export { render, staticRenderFns }